import { Fragment } from 'react';
import { splitTokens } from './segments';

/** Gespeicherter Text mit seinen Feldern als kleine Marken — lesbar, was später eingesetzt wird. */
export function TokenText({ text }: { text: string }) {
  return (
    <>
      {splitTokens(text, () => 'field').map((segment, index) =>
        segment.kind === 'field' ? (
          <span key={index} className="bg-postmark/15 text-ink rounded px-1 font-medium">
            {segment.text.slice(2, -2).trim()}
          </span>
        ) : (
          <Fragment key={index}>{segment.text}</Fragment>
        ),
      )}
    </>
  );
}
